<template>
    <div>
        <div class="card my-4">
            <h5 class="card-header">Deixe um comentário:</h5>
            <div class="card-body">
            <form>
                <div class="form-group">
                    <label for="Nome">Nome</label>
                    <input type="text" name="nome" id="Nome" placeholder="Nome" class="form-control"
                    min="5" max="191"
                    :class="{ 'is-invalid': comentario.errors.has('nome') }" v-model="comentario.nome">
                    <has-error :form="comentario" field="nome"></has-error>
                </div>
                <div class="form-group">
                    <label for="Email">E-mail</label>
                    <input type="email" name="email" id="Email" placeholder="pessoa@firma.com.br" class="form-control"
                    min="5" max="191"
                    :class="{ 'is-invalid': comentario.errors.has('email') }" v-model="comentario.email">
                    <has-error :form="comentario" field="email"></has-error>
                </div>
                <div class="form-group">
                    <label for="Comentario">Comentário</label>
                    <textarea class="form-control" rows="3" min="5" max="300"
                    :class="{ 'is-invalid': comentario.errors.has('comentario') }" v-model="comentario.comentario"></textarea>
                    <has-error :form="comentario" field="comentario"></has-error>
                </div>
                <button type="button" class="btn btn-primary" @click.prevent="comentar"> <i class="fas fa-paper-plane"></i> Enviar</button>
            </form>
            </div>
        </div>
        <div v-if="comentarios.length == 0" class="media mt-3">
            <h5 class="text-center">Não há comentários disponíveis. Seja o primeiro a comentar! :D</h5>
        </div>
        <div v-else>
            <div v-for="(c, i) in comentarios" class="media mb-4" :key="i">
                <div class="media-body">
                <h5 class="mt-0">{{c.nome}}</h5>
                    {{c.comentario}}
                <br>
                <div>
                    <button class="btn btn-sm btn-light" @click.prevent="likeComentario(c.reacoes[0].id, c)"><i class="far fa-thumbs-up"></i> Gostei {{c.reacoes[0].likes}}</button>
                    <button class="btn btn-sm btn-light" @click.prevent="dislikeComentario(c.reacoes[0].id, c)"><i class="far fa-thumbs-down"></i> Não gostei {{c.reacoes[0].dislikes}}</button>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                post_id: '',
                location: window.location.host,
                comentario: new vForm({
                    id: '',
                    nome: '',
                    email: '',
                    comentario: '',
                    autorize: false,
                    resposta: false,
                    postagem_id: '',
                    towho: ''
                }),
                comentarios: {},
            }
        },
        props:{
            post:{
                required: true
            }
        },
        methods:{
            comentar(){
                this.$Progress.start();
                this.comentario.post('https://'+this.location+'/api/comentario')
                    .then(({data})=>{
                        Swal.fire({
                            icon: 'success',
                            title: 'Comentário enviado. Aguarde moderação.'
                        });
                        this.comentario.clear();
                        this.comentario.reset();
                        this.$Progress.finish();
                    })
                    .catch(()=>{
                        Swal.fire({
                            icon: 'error',
                            title: 'Comentário não enviado. Algo aconteceu...'
                        });
                        this.$Progress.fail();
                    });
            },
            getData(){
                axios.get('/api/comentariosFromPost/'+this.post.id)
                    .then(({data}) => {
                        this.comentarios = data;
                    });
            },
            likeComentario(id, comentario){
                this.$Progress.start();
                axios.post('https://'+this.location+'/api/likeComentario/'+id)
                    .then(({data})=>{
                        toast.fire({
                            icon: 'success',
                            title: 'Reação salva com sucesso.'
                        });
                        comentario.reacoes[0].likes = data.likes;
                        this.$Progress.finish();
                    })
                    .catch(()=>{
                        toast.fire({
                            icon: 'error',
                            title: 'Reação não salva. Algo aconteceu...'
                        });
                        this.$Progress.fail();
                    });
            },
            dislikeComentario(id, comentario){
                this.$Progress.start();
                axios.post('https://'+this.location+'/api/dislikeComentario/'+id)
                    .then(({data})=>{
                        toast.fire({
                            icon: 'success',
                            title: 'Reação salva com sucesso.'
                        });
                        comentario.reacoes[0].dislikes = data.dislikes;
                        this.$Progress.finish();
                    })
                    .catch(()=>{
                        toast.fire({
                            icon: 'error',
                            title: 'Reação não salva. Algo aconteceu...'
                        });
                        this.$Progress.fail();
                    });
            },
        },
        mounted() {
            
        },
        watch: {
            post: function(){
                this.post_id = this.post.id;
                this.comentario.postagem_id = this.post_id;
                this.getData();
            }
        }
    }
</script>
